import { getNumber } from "../../utils";

export interface SelectedNGO {
    _id: string;
    value: string;
    projects?: Array<{ _id: string; value: string }>;
}

export interface SelectedOrg {
    _id: string;
    value: string;
}

export enum CampaignQueryParam {
    CAMPAIGN_ID = "campaignId",
    TYPE = "type",
    CITY = "city",
    EMAIL = "email",
}


export enum ParamTypes {
    ORGANIZATION = "Organization",
    NGO = "Ngo"
}

export const calculateTotalPledgedAmount = (
    selectedNGOS: SelectedNGO[],
    selectedOrg: SelectedOrg[]
): number => {
    let total = 0;

    selectedNGOS.forEach((ngo) => {
        (ngo.projects || []).forEach((proj) => {
            total += getNumber(proj.value || "0");
        });
    });

    selectedOrg.forEach((org) => {
        total += getNumber(org.value || "0");
    });

    return total;
};